import React from "react";
import { useTheme } from "../../theme/ThemeContext";
import {
  getOrderCurrentPrice,
  getOrderOpenPrice,
  getOrderTypeLabel,
  getOrderVolumeLots,
  isBuyOrder,
} from "../../services/platform/TradingStore";
import {
  formatDateTime,
  formatPrice,
  getBalanceHistoryLabel,
  getTicketValue,
  toNumber,
} from "./portfolioUtils";

const HistoryRow = ({ order, onDetail }) => {
  const theme = useTheme();
  const profit = toNumber(
    order.calculatedProfit ?? order.profit ?? order.netProfit,
  );
  const pColor = profit >= 0 ? theme.pos : theme.neg;
  const closeTime = order?.timeMsc;
  if (order.isBalanceHistory) {
    const label = getBalanceHistoryLabel(order);

    return (
      <div
        onDoubleClick={() => onDetail(order, "history")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 12px",
          borderBottom: `1px solid ${theme.border}22`,
          cursor: "pointer",
        }}
      >
        <div style={{ minWidth: 0, flex: 1 }}>
          <div
            style={{
              display: "flex",
              gap: 6,
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <span style={{ fontSize: 12, fontWeight: 700, color: theme.text }}>
              {label}
            </span>
            <span style={{ fontSize: 10, color: theme.textM, fontWeight: 500 }}>
              #{getTicketValue(order)}
            </span>
          </div>
          <div style={{ fontSize: 11, color: theme.textM }}>
            <span>{order.comment || "Balance operation"}</span>
            <span style={{ color: theme.textM, marginLeft: 8, fontSize: 10 }}>
              {formatDateTime(closeTime)}
            </span>
          </div>
        </div>
        <span
          style={{
            fontFamily: theme.mono,
            fontVariantNumeric: "tabular-nums",
            fontWeight: 700,
            color: pColor,
            fontSize: 12,
            flexShrink: 0,
          }}
        >
          {profit >= 0 ? "+" : ""}
          {profit.toFixed(2)}
        </span>
      </div>
    );
  }

  const vol = getOrderVolumeLots(order).toFixed(2);
  const typeLabel = getOrderTypeLabel(order);
  const openPrice =
    toNumber(order.calculatedOpenPrice) || getOrderOpenPrice(order);
  const closePrice =
    toNumber(order.calculatedClosePrice) ||
    getOrderCurrentPrice(order) ||
    openPrice;
  const hasOpenPrice = Boolean(
    toNumber(
      order.calculatedOpenPrice ??
      order.open_price ??
      order.openPrice ??
      order.price_open ??
      order.priceOpen,
    ),
  );

  return (
    <div
      onDoubleClick={() => onDetail(order, "history")}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 12px",
        borderBottom: `1px solid ${theme.border}22`,
        cursor: "pointer",
      }}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            display: "flex",
            gap: 6,
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 700, color: theme.text }}>
            {order.symbol}
          </span>
          <span
            style={{
              fontSize: 10,
              color: isBuyOrder(order) ? theme.pos : theme.neg,
              fontWeight: 600,
            }}
          >
            {typeLabel}
          </span>
          <span style={{ fontSize: 10, color: theme.textM, fontWeight: 500 }}>
            #{getTicketValue(order)}
          </span>
        </div>
        <div style={{ fontSize: 11, color: theme.textM }}>
          <span style={{ fontSize: 10, color: theme.textM }}>{vol} lots</span>
          {hasOpenPrice && (
            <>
              <span style={{ fontFamily: theme.mono, margin: "0 4px" }}>
                {formatPrice(openPrice, order.digits ?? 5)}
              </span>
              <span style={{ color: theme.textM, margin: "0 4px" }}>{"->"}</span>
            </>
          )}
          {!hasOpenPrice && (
            <span style={{ color: theme.textM, marginLeft: 4 }}>Closed @</span>
          )}
          <span style={{ fontFamily: theme.mono }}>
            {formatPrice(closePrice, order.digits ?? 5)}
          </span>
          <span style={{ color: theme.textM, marginLeft: 8, fontSize: 10 }}>
            {formatDateTime(closeTime)}
          </span>
        </div>
      </div>
      <span
        style={{
          fontFamily: theme.mono,
          fontVariantNumeric: "tabular-nums",
          fontWeight: 700,
          color: pColor,
          fontSize: 12,
          flexShrink: 0,
        }}
      >
        {profit >= 0 ? "+" : ""}
        {profit.toFixed(2)}
      </span>
    </div>
  );
};

export default React.memo(HistoryRow);
